import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { User, Lock, Mail, ArrowRight, CheckCircle } from 'lucide-react';
export function AccountPage() {
  const [activeTab, setActiveTab] = useState<'login' | 'signup'>('login');
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-290">
      <Header data-id="element-291" />

      <main className="flex-grow bg-gray-50 py-16 md:py-24" data-id="element-292">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-293">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden" data-id="element-294">
            <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-295">
              {/* Left Side - Info & Benefits */}
              <div className="bg-gradient-to-br from-purple-600 to-teal-600 p-12 text-white flex flex-col justify-center" data-id="element-296">
                <h2 className="text-3xl font-bold mb-6" data-id="element-297">Welcome Back!</h2>
                <p className="text-purple-100 mb-8 text-lg" data-id="element-298">
                  Join our community to access exclusive features and streamline
                  your custom apparel ordering experience.
                </p>

                <div className="space-y-4" data-id="element-299">
                  <div className="flex items-center space-x-3" data-id="element-300">
                    <CheckCircle className="h-5 w-5 text-teal-300" data-id="element-301" />
                    <span data-id="element-302">Track your order status in real-time</span>
                  </div>
                  <div className="flex items-center space-x-3" data-id="element-303">
                    <CheckCircle className="h-5 w-5 text-teal-300" data-id="element-304" />
                    <span data-id="element-305">Save designs for future re-orders</span>
                  </div>
                  <div className="flex items-center space-x-3" data-id="element-306">
                    <CheckCircle className="h-5 w-5 text-teal-300" data-id="element-307" />
                    <span data-id="element-308">Faster checkout with saved details</span>
                  </div>
                  <div className="flex items-center space-x-3" data-id="element-309">
                    <CheckCircle className="h-5 w-5 text-teal-300" data-id="element-310" />
                    <span data-id="element-311">Exclusive access to special offers</span>
                  </div>
                </div>
              </div>

              {/* Right Side - Forms */}
              <div className="p-12" data-id="element-312">
                <div className="flex space-x-6 mb-8 border-b border-gray-100 pb-4" data-id="element-313">
                  <button onClick={() => setActiveTab('login')} className={`text-lg font-medium pb-2 transition-colors ${activeTab === 'login' ? 'text-purple-600 border-b-2 border-purple-600' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-314">
                    Log In
                  </button>
                  <button onClick={() => setActiveTab('signup')} className={`text-lg font-medium pb-2 transition-colors ${activeTab === 'signup' ? 'text-purple-600 border-b-2 border-purple-600' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-315">
                    Create Account
                  </button>
                </div>

                {activeTab === 'login' ? <form className="space-y-6" data-id="element-316">
                    <div data-id="element-317">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-318">
                        Email Address
                      </label>
                      <div className="relative" data-id="element-319">
                        <Mail className="absolute left-3 top-3 h-5 w-5 text-gray-400" data-id="element-320" />
                        <input type="email" className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none" placeholder="you@example.com" data-id="element-321" />
                      </div>
                    </div>

                    <div data-id="element-322">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-323">
                        Password
                      </label>
                      <div className="relative" data-id="element-324">
                        <Lock className="absolute left-3 top-3 h-5 w-5 text-gray-400" data-id="element-325" />
                        <input type="password" className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none" placeholder="••••••••" data-id="element-326" />
                      </div>
                      <div className="flex justify-end mt-2" data-id="element-327">
                        <a href="#" className="text-sm text-purple-600 hover:text-purple-700 font-medium" data-id="element-328">
                          Forgot Password?
                        </a>
                      </div>
                    </div>

                    <button type="submit" className="w-full bg-purple-600 hover:bg-purple-700 text-white font-medium py-3 rounded-full shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-2" data-id="element-329">
                      Log In
                      <ArrowRight className="h-4 w-4" data-id="element-330" />
                    </button>
                  </form> : <form className="space-y-6" data-id="element-331">
                    <div data-id="element-332">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-333">
                        Full Name
                      </label>
                      <div className="relative" data-id="element-334">
                        <User className="absolute left-3 top-3 h-5 w-5 text-gray-400" data-id="element-335" />
                        <input type="text" className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none" placeholder="John Doe" data-id="element-336" />
                      </div>
                    </div>

                    <div data-id="element-337">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-338">
                        Email Address
                      </label>
                      <div className="relative" data-id="element-339">
                        <Mail className="absolute left-3 top-3 h-5 w-5 text-gray-400" data-id="element-340" />
                        <input type="email" className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none" placeholder="you@example.com" data-id="element-341" />
                      </div>
                    </div>

                    <div data-id="element-342">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-343">
                        Password
                      </label>
                      <div className="relative" data-id="element-344">
                        <Lock className="absolute left-3 top-3 h-5 w-5 text-gray-400" data-id="element-345" />
                        <input type="password" className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none" placeholder="Create a password" data-id="element-346" />
                      </div>
                    </div>

                    <button type="submit" className="w-full bg-teal-500 hover:bg-teal-600 text-white font-medium py-3 rounded-full shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-2" data-id="element-347">
                      Create Account
                      <ArrowRight className="h-4 w-4" data-id="element-348" />
                    </button>
                  </form>}
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-349" />
    </div>;
}